import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";
import getRefreshToken from "../../Services/token";
import { downloadExcel } from "react-export-table-to-excel";
import Toaster from "../../components/Toaster";
import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

import { api } from "../../Services/index";
import { axiosClient, config } from "./../../Services/Config";
// var apiConfig = require('../../Services/constant.json')[process.env.REACT_APP_ENV || 'dev'];
const { REACT_APP_ENV } = process.env;
var apiConfig = require("../../Services/constant.json")[REACT_APP_ENV.trim()];

import { CSVLink } from "react-csv";
// import ReactExport from "react-data-export";
import { event } from "jquery";

//pdf viewer
import AllPagesPDFViewer from "../dcg_viewer_pdf/all-pages";
import SweetAlert from "react-bootstrap-sweetalert";
import IdleTimer from "../../common/IdleTimer";
import AttachmentModal from "../../common/attachment";
import AssociateNotes from "../../common/associateNotes";
var momentt = require("moment-timezone");

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//   const csvExportHeaders = [
//     { label: "Date", key: "date1" },
//     { label: "Total Number of Comfort Guides Created", key: "totalcomfortguide" },
//     { label: "Sketches Made", key: "totalskecthes" },
//     { label: "Comfort Guides Email", key: 'totalemail' },
//     { label: "Comfort Guides Printed", key: 'totalprint' }
//   ];

const csvExportHeaders = [
  { label: "Date", key: "date1" },
  { label: "Total Guides", key: "totalcomfortguide" },
  { label: "Sketches", key: "totalskecthes" },
  { label: "Email", key: "totalemail" },
  { label: "Batch Email", key: "totalbatchemail" },
  { label: "Printed", key: "totalprint" },
  { label: "Design Appointment", key: "totalappointment" },
  { label: "Follow Up", key: "totaltask" },
];
const header = [
  "Date",
  "Total Guides",
  "Sketches",
  "Email",
  "Design Appointment",
  "Printed",
  "Follow Up",
];

const loaderStyle = {
  color: "#f3f3f3",
};

const pdfviewerStyle = {
  BorderTop: "2px solid black",
  display: "flex",
};

class DailySummary extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 1,
      markets: [],
      stores: [],
      associates: [],
      selectedMarket: 0,
      selectedStore: [],
      selectedMarketAllStores: [],
      selectedAssociate: null,
      toasterMessage: "",
      toasterType: "",
      startDate: moment().subtract(7, "days").format("MM/DD/YYYY"),
      endDate: moment().format("MM/DD/YYYY"),
      dateLabel: "",
      dailySummaryData: [],
      spinnerColor: "#000000",
      spinnerLoading: false,
      userLoggedIn: false,
      loginname: null,
      userloginid: null,

      //pdf viewer
      pdfDCGIds: [],
      samplePdfFilesList: [],
      currentPdfFileUrl:
        apiConfig.base_url + "/dcgforms/print?dcgid=1803&type=stream",
      currentPdfFileIndex: 0,
      btnPrevPdfDisabled: true,
      btnNextPdfDisabled: true,
      showPdfPreview: false,
      showResultGrid: true,
      showAttachmentModal: false,
    };
    this.changeMarket = this.changeMarket.bind(this);
    this.changeStore = this.changeStore.bind(this);
    this.changeAssociate = this.changeAssociate.bind(this);
    this.handleCalenderEvent = this.handleCalenderEvent.bind(this);
    this.handleCalenderCallback = this.handleCalenderCallback.bind(this);
    this.showResults = this.showResults.bind(this);

    //pdf viewer
    this.viewPDF = this.viewPDF.bind(this);
    this.clickPrevPdf = this.clickPrevPdf.bind(this);
    this.clickNextPdf = this.clickNextPdf.bind(this);
    this.closePdfViewer = this.closePdfViewer.bind(this);
  }

  componentDidMount() {
    this.state.diff = moment().utcOffset(moment().format().toString())._offset;
    this.state.timezonelabel = momentt.tz(momentt.tz.guess()).zoneAbbr();
    this.setUserInfo();
    this.getMarketData();
    this.getStoreData(this.state.selectedMarket);
    this.getAssociateData(this.state.selectedMarket, 0);
    var searchObj = {
      startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
      salesrepid: this.state.selectedAssociate,
      timezone: "EST",
      storeId: [],
    };
    this.getDailySummaryData(searchObj);
  }

  // pdf viewer Prev Next
  clickPrevPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    let index = this.state.currentPdfFileIndex - 1;
    let disabledPrev = false;
    if (index <= 0) {
      index = 0;
      disabledPrev = true;
    }

    this.setState({
      currentPdfFileIndex: index,
      btnPrevPdfDisabled: disabledPrev,
      btnNextPdfDisabled: false,
      showPdfPreview: true,
    });
  };

  // pdf viewer Prev Next
  clickNextPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    let index = this.state.currentPdfFileIndex + 1;
    let disabledNext = false;

    if (index === this.state.samplePdfFilesList.length - 1) {
      index = this.state.samplePdfFilesList.length - 1;
      disabledNext = true;
    }

    this.setState({
      currentPdfFileIndex: index,
      btnPrevPdfDisabled: false,
      btnNextPdfDisabled: disabledNext,
      showPdfPreview: true,
    });
  };

  clickPrintPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    window.open(
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl,
      "PRINT",
      "height=600,width=800",
    );
  };

  clickDownloadPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    let url = new URL(
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl,
    );
    let params = new URLSearchParams(url.search);
    params.delete("type");
    window.location.href = url.origin + "" + url.pathname + "?" + params;
  };

  // close Pdf Viewer
  closePdfViewer = () => {
    this.setState({
      showPdfPreview: false,
      showResultGrid: true,
    });
  };

  onCancelPdfViewerPopup = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    this.setState({
      showPdfPreview: false,
      showResultGrid: true,
    });
  };

  onConfirmPdfViewerPopup = () => {
    this.setState({
      showPdfPreview: false,
      showResultGrid: true,
    });
  };

  setUserInfo = () => {
    var userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userinfo) {
      this.setState({
        loginname: userinfo.roleinfo.loginname,
        userloginid: userinfo.roleinfo.userloginid,
        userLoggedIn: true,
      });
    } else {
      if (err !== undefined) {
        this.props.history.push("/login");
      }
      // return;
    }
  };

  handleCalenderEvent(event, datepicker) {
    this.setState({
      startDate: moment(datepicker.startDate).format("MM/DD/YYYY"),
      endDate: moment(datepicker.endDate).format("MM/DD/YYYY"),
      dateLabel:
        moment(datepicker.startDate).format("MM/DD/YYYY") +
        " to " +
        moment(datepicker.endDate).format("MM/DD/YYYY"),
    });
  }

  handleCalenderCallback(start, end, label) {}

  changeMarket(event) {
    this.setState({ selectedMarket: event.target.value });
    this.setState({ selectedStore: [] });
    this.getStoreData(event.target.value);
    this.setState({ selectedAssociate: null });
    this.getAssociateData(event.target.value, 0);
  }

  changeStore(event) {
    // var tmpStores = (Number(event.target.value)===0 ? [] : [event.target.value]);
    var tmpStores =
      Number(event.target.value) === 0
        ? this.state.selectedMarketAllStores
        : [event.target.value];
    tmpStores.push();
    this.setState({ selectedStore: tmpStores });
    this.setState({ selectedAssociate: null });
    this.getAssociateData(this.state.selectedMarket, event.target.value);
  }

  changeAssociate(event) {
    // var tmpAssociate = (Number(event.target.value)===0 ? [] : [event.target.value]);
    // this.setState({selectedAssociate: tmpAssociate});

    var tmpAssociate =
      Number(event.target.value) === 0 ? null : event.target.value;
    this.setState({ selectedAssociate: event.target.value });
  }

  tabchangeevent = (e) => {
    this.setState({ tab: e });
  };

  onfieldChange = (e, key) => {};

  getMarketData() {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getMarketData()
        .then((data) => {
          this.setState({
            markets: data.data,
            spinnerLoading: false,
          });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  getStoreData(marketId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getStoreData(marketId)
        .then((data) => {
          this.setState({
            stores: data.data,
            spinnerLoading: false,
          });

          const arrMarketStoreIds = data.data.reduce(
            (r, c) => (
              r.storeid.push(c.storeid),
              r.marketid.push(c.marketid),
              r
            ),
            { storeid: [], marketid: [] },
          );
          this.setState({ selectedStore: arrMarketStoreIds.storeid });
          this.setState({ selectedMarketAllStores: arrMarketStoreIds.storeid });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  getAssociateData(marketId, storeId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getAssociateData(marketId, storeId)
        .then((data) => {
          this.setState({
            associates: data.data,
            spinnerLoading: false,
          });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  getDailySummaryData(searchParam) {
    try {
      this.setState({ spinnerLoading: true });
      var actionPayload = searchParam;
      api
        .getDailySummaryDataPost(actionPayload)
        .then((data) => {
          if (data && data.response && data.response.status == 401) {
            this.getrefreshtoken(actionPayload);
          } else {
            this.setState({
              dailySummaryData: data.data.data,
              spinnerLoading: false,
            });
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
          this.setState({
            spinnerLoading: false,
          });
          this.toggleToaster(
            "Failed to retrieve data from the API. Please try again later.",
            "error",
          );
        });
    } catch (e) {}
  }
  toggleToaster(message, type) {
    this.setState({
      toasterMessage: message,
      toasterType: type,
    });

    setTimeout(() => {
      this.setState({
        toasterMessage: null,
        toasterType: undefined,
      });
    }, 4000);
  }
  getrefreshtoken(actionPayload) {
    getRefreshToken()
      .then((res) => {
        api
          .getDailySummaryDataPost(actionPayload)
          .then((data) => {
            this.setState({
              dailySummaryData: data.data.data,
              spinnerLoading: false,
            });
            this.getMarketData();
            this.getStoreData(this.state.selectedMarket);
            this.getAssociateData(this.state.selectedMarket, 0);
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      })
      .catch((err) => {
        this.props.history.push("/login");
      });
  }

  showResults = () => {
    var searchObj = {};

    if (this.state.selectedStore) {
      searchObj["storeId"] = this.state.selectedStore;
    } else {
      searchObj["storeId"] = [];
    }
    if (this.state.selectedAssociate) {
      searchObj["salesrepid"] =
        Number(this.state.selectedAssociate) === 0
          ? null
          : this.state.selectedAssociate;
    } else {
      searchObj["salesrepid"] = null;
    }
    if (this.state.startDate) {
      searchObj["startDate"] = moment(this.state.startDate).format(
        "YYYY-MM-DD",
      );
    }
    if (this.state.endDate) {
      searchObj["endDate"] = moment(this.state.endDate).format("YYYY-MM-DD");
    }
    searchObj["timezone"] = "EST";

    this.getDailySummaryData(searchObj);
  };

  renderTableHeader() {
    var header = [];
    header =
      this.state.dailySummaryData[0] &&
      Object.keys(this.state.dailySummaryData[0]);
    return (
      <tr key="tabheader">
        <th>Date</th>
        <th>Total Guides</th>
        <th>Sketches</th>
        <th>Email</th>
        <th>Batch Email</th>
        <th>Printed</th>
        <th>Design Appointment</th>
        <th>Follow Up</th>
      </tr>

      // <tr key='tabheader'>
      //    <th>Date</th>
      //    <th>Total Number of Comfort Guides Created</th>
      //    <th>Sketches Made</th>
      //    <th>Comfort Guides Email</th>
      //    <th>Comfort Guides Printed</th>
      // </tr>
    );
  }

  renderTableData() {
    return (
      this.state.dailySummaryData &&
      this.state.dailySummaryData.map((data, index) => {
        const {
          date1,
          totalcomfortguide,
          totalskecthes,
          totalemail,
          totalbatchemail,
          totalprint,
          dcgids,
          totalappointment,
          totaltask,
          designer_dcgids,
        } = data;
        return (
          <tr class={date1 == "Total" ? "total" : ""} key={index}>
            <td>{date1}</td>
            {/* <td>{(totalcomfortguide===null || totalcomfortguide==='0') ? 0 : <a href='dcg-viewer'> {(totalcomfortguide)} </a>}</td> */}
            {/* <td>{(totalcomfortguide===null || totalcomfortguide==='0') ? 0 :  (date1=='Total'? totalcomfortguide : <a  href='dcg-viewer'> {(totalcomfortguide)} </a> )   }</td> */}
            <td>
              {totalcomfortguide === null || totalcomfortguide === "0" ? (
                0
              ) : date1 == "Total" ? (
                totalcomfortguide
              ) : (
                <a
                  href="javascript:void(0);"
                  onClick={(e) => this.viewPDF(dcgids, e)}
                >
                  {" "}
                  {totalcomfortguide}{" "}
                </a>
              )}
            </td>
            <td>{totalskecthes === null ? 0 : totalskecthes}</td>
            <td>{totalemail === null ? 0 : totalemail}</td>
            <td>{totalbatchemail === null ? 0 : totalbatchemail}</td>
            <td>{totalprint === null ? 0 : totalprint}</td>
            <td>
              {totalappointment === null || totalappointment === "0" ? (
                0
              ) : date1 == "Total" ? (
                totalappointment
              ) : (
                <a
                  href="javascript:void(0);"
                  onClick={(e) => this.viewPDF(designer_dcgids, e)}
                >
                  {" "}
                  {totalappointment}{" "}
                </a>
              )}
            </td>
            <td>{totaltask === null ? 0 : totaltask}</td>
          </tr>
        );
      })
    );
  }

  renderTotalData() {
    return (
      <tr class="total" key="totalrow">
        <td>&nbsp;</td>
        <td>0</td>
        <td>0</td>
        <td>0</td>
        <td>0</td>
        <td></td>
        <td></td>
      </tr>
    );
  }
  formatStoreNumber = (number) => {
    return String(number).padStart(3, "0");
  };
  renderTable() {
    return (
      <div id="daily-summary-table">
        <table class="table table-bordered table-striped" id="table-data">
          <thead>{this.renderTableHeader()}</thead>
          <tbody>
            {this.renderTableData()}
            {/* {this.renderTotalData()} */}
          </tbody>
        </table>
      </div>
    );
  }
  hiddennotes = () => {
    this.state.activeDCGID =
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].dcgid;
    this.setState({
      showHiddenNotesModal: true,
    });
    this.openAttachmentModal(false);
  };
  openFN = async (dcgid) => {
    this.state.activeDCGID =
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].dcgid;
    this.setState({ showAttachmentModal: true });
    this.hiddenNotesModal(false);
  };
  viewPDF = (dcgids, e) => {
    e.preventDefault();
    dcgids = dcgids.substring(1, dcgids.length - 1);
    var arrdcgids = dcgids.split(",");
    const tmpPdfUrls = [];
    this.setState({ pdfDCGIds: arrdcgids }, () => {
      for (let i = 0; i <= arrdcgids.length - 1; i++) {
        tmpPdfUrls.push({
          dcgid: this.state.pdfDCGIds[i],
          fileurl:
            apiConfig.base_url +
            "/dcgforms/print?dcgid=" +
            this.state.pdfDCGIds[i] +
            "&type=stream" +
            "&timezonediff=" +
            this.state.diff +
            "&timezonelabel=" +
            this.state.timezonelabel,
        });
      }

      this.setState(
        {
          samplePdfFilesList: tmpPdfUrls,
          currentPdfFileUrl: tmpPdfUrls[0].fileurl,
          currentPdfFileIndex: 0,
          btnPrevPdfDisabled: true,
          btnNextPdfDisabled: tmpPdfUrls.length <= 1,
          showPdfPreview: true,
          showResultGrid: false,
        },
        () => {
          console.log("set state");
          // console.log(this.state)
        },
      );
    });
  };

  handleDownloadExcel = () => {
    var obj = {
      date1: "Date",
      totalcomfortguide: "Total Guides",
      totalskecthes: "Sketches",
      totalemail: "Email",
      totalbatchemail: "Batch Email",
      totalprint: "Printed",
      totalappointment: "Design Appointment",
      totaltask: "Follow Up",
    };
    const header = [
      "Date",
      "Total Guides",
      "Sketches",
      "Email",
      "Batch Email",
      "Printed",
      "Design Appointment",
      "Follow Up",
    ];
    var dataInXl = [];
    this.state.dailySummaryData.map((c, i) => {
      for (var key in obj) {
        if (!dataInXl[i]) {
          dataInXl[i] = [];
          dataInXl[i].push(c[key]);
        } else {
          dataInXl[i].push(c[key]);
        }
      }
    });
    downloadExcel({
      fileName: "Daily_Summary",
      sheet: "Daily_Summary",
      tablePayload: {
        header,
        // accept two different data structures
        body: dataInXl,
      },
    });
  };
  hiddenNotesModal = (flag) => {
    this.setState({ showHiddenNotesModal: flag });
  };
  openAttachmentModal = (flag) => {
    this.setState({ showAttachmentModal: flag });
  };

  render() {
    return (
      <div className="wrapper">
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          <Header />
          <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
          <IdleTimer></IdleTimer>
          {this.state.showHiddenNotesModal && (
            <AssociateNotes
              dcgId={this.state.activeDCGID}
              hiddenNotesModal={this.hiddenNotesModal}
            />
          )}
          {this.state.showAttachmentModal && (
            <AttachmentModal
              dcgId={this.state.activeDCGID}
              openAttachmentModal={this.openAttachmentModal}
            />
          )}
          <div className="content-wrapper pb-4">
            {this.state.toasterMessage ? (
              <Toaster
                message={this.state.toasterMessage}
                toasterType={this.state.toasterType}
              />
            ) : null}
            {this.state.showResultGrid === true && (
              <section class="content">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-8">
                      <h5>Daily Summary Report</h5>
                    </div>
                    <div class="col-md-4  alertStyle">
                      <p class="alertStyle">
                        * All the reports are displaying in EST timezone
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <hr />
                    </div>
                  </div>
                  {/* <form name="myform" method="post" action={apiConfig.base_url+'/admin/reports/dailysummaryreports'}
                                    target="_blank">
                                    <input type="hidden" name="startDate" value={moment(this.state.startDate).format("YYYY-MM-DD")} />
                                    <input type="hidden" name="endDate" value={moment(this.state.endDate).format("YYYY-MM-DD")} />
                                    <input type="hidden" name="type" value={'download'} />
                                    { this.state.selectedStore && <input type="hidden" name="storeId" value={this.state.selectedStore.join(',')} />}
                                    <input type="hidden" name="salesrepid" value={this.state.associateId} />
                                </form> */}

                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Market</label>
                        <select
                          className="form-control"
                          value={this.state.selectedMarket}
                          onChange={this.changeMarket}
                        >
                          <option value={0}>All</option>
                          {this.state.markets &&
                            this.state.markets.map((market, key) => (
                              <option value={market.marketid}>
                                {market.marketname}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Store</label>
                        <select
                          className="form-control"
                          value={this.state.selectedStore}
                          onChange={this.changeStore}
                        >
                          <option value={0}>All</option>
                          {this.state.stores &&
                            this.state.stores.map((str, key) => (
                              <option value={str.storeid}>
                                {this.formatStoreNumber(str.naturalstoreid)}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Associate</label>
                        <select
                          className="form-control"
                          value={this.state.selectedAssociate}
                          onChange={this.changeAssociate}
                        >
                          <option value={0}>All</option>
                          {this.state.associates &&
                            this.state.associates.map((asst, key) => (
                              <option value={asst.userloginid}>
                                {asst.loginname}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Date Range</label>
                        <div class="input-group">
                          <DateRangePicker
                            onEvent={this.handleCalenderEvent}
                            onChange={this.handleCalenderEvent}
                            onApply={this.handleCalenderEvent}
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                            }}
                          >
                            <input type="text" className="form-control" />
                          </DateRangePicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group mt-1 pt-4">
                        <a
                          href="#"
                          onClick={this.showResults}
                          class="btn btn-primary"
                        >
                          Show
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                    {!(
                      Object.entries(this.state.dailySummaryData).length === 0
                    ) && (
                      <div class="col-md-12 text-right">
                        <label>Export : &nbsp; </label>
                        <img
                          src="dist/img/excel-icon.png"
                          className="pointer"
                          title="Export to Excel"
                          onClick={() => {
                            this.handleDownloadExcel();
                          }}
                        />
                        {/* <ExcelFile element={<a href="javascript:void(0);" class="mr-2"><img src="dist/img/excel-icon.png" title="Export to Excel" /></a>}>
                                                    <ExcelSheet data={this.state.dailySummaryData} name="Daily_Summary">
                                                        <ExcelColumn label="Date" value="date1" />
                                                        <ExcelColumn label="Total Guides" value={(col) => (col.totalcomfortguide === null) ? "0" : col.totalcomfortguide} />
                                                        <ExcelColumn label="Sketches" value={(col) => (col.totalskecthes === null) ? "0" : col.totalskecthes} />
                                                        <ExcelColumn label="Email" value={(col) => (col.totalemail === null) ? "0" : col.totalemail} />
                                                        <ExcelColumn label="Batch Email" value={(col) => (col.totalbatchemail === null) ? "0" : col.totalbatchemail} />
                                                        <ExcelColumn label="Printed" value={(col) => (col.totalprint === null) ? "0" : col.totalprint} />
                                                        <ExcelColumn label="Design Appointment" value={(col) => (col.totalappointment === null) ? "0" : col.totalappointment} />
                                                        <ExcelColumn label="Follow Up" value={(col) => (col.totaltask === null) ? "0" : col.totaltask} />
                                                    </ExcelSheet>
                                                </ExcelFile> */}

                        <CSVLink
                          headers={csvExportHeaders}
                          data={this.state.dailySummaryData.map((row) => ({
                            ...row,
                            totalcomfortguide:
                              row.totalcomfortguide === null
                                ? "0"
                                : row.totalcomfortguide,
                            totalskecthes:
                              row.totalskecthes === null
                                ? "0"
                                : row.totalskecthes,
                            totalemail:
                              row.totalemail === null ? "0" : row.totalemail,
                            totalbatchemail:
                              row.totalbatchemail === null
                                ? "0"
                                : row.totalbatchemail,
                            totalprint:
                              row.totalprint === null ? "0" : row.totalprint,
                            totalappointment:
                              row.totalappointment === null
                                ? "0"
                                : row.totalappointment,
                            totaltask:
                              row.totaltask === null ? "0" : row.totaltask,
                          }))}
                          filename="Daily_Summary.csv"
                        >
                          <img
                            src="dist/img/csv-icon.png"
                            title="Export to CSV"
                          />
                        </CSVLink>
                      </div>
                    )}
                    {!(
                      Object.entries(this.state.dailySummaryData).length === 0
                    ) && (
                      <div class="col-md-12">
                        {this.renderTable()}
                        {/* {this.exportExcel2()} */}
                      </div>
                    )}
                    {Object.entries(this.state.dailySummaryData).length ===
                      0 && (
                      <div class="col-md-12">Sorry, No Records found!</div>
                    )}
                  </div>
                </div>
              </section>
            )}

            {this.state.showPdfPreview === true && (
              <div>
                <SweetAlert
                  showConfirm={false}
                  onCancel={this.onCancelPdfViewerPopup}
                  style={{
                    color: "#000000",
                    fontSize: "11px",
                    minWidth: "80%",
                    marginTop: "30px",
                    overflow: "auto",
                    overflowY: "visible",
                  }}
                  closeOnClickOutside={true}
                  allowEscape={true}
                  btnSize={"sm"}
                  customClass="containerBox"
                >
                  {/* <div class="row">
                            <div class="col-md-12">
                                <h5>DCG Viewer</h5>
                                <hr />
                            </div>
                            </div> */}
                  <div class="row">
                    <div class="col-md-12">
                      <h5
                        style={{
                          textAlign: "right",
                          color: "#2470af",
                          cursor: "pointer",
                          fontSize: "28px",
                        }}
                        onClick={this.onCancelPdfViewerPopup}
                      >
                        {" "}
                        <i class="fas fa-times"></i>
                      </h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8" style={{ textAlign: "center" }}>
                      <h4>DCG Viewer</h4>
                    </div>
                    <div class="col-md-2" style={{ textAlign: "right" }}>
                      <a>
                        <img
                          src={require("../../dist/img/iconnotes.png")}
                          className="mr-3 notecolor"
                          style={{ marginBottom: 10, cursor: "pointer" }}
                          onClick={this.hiddennotes}
                          data-toggle="modal"
                          data-target="#hiddennotes"
                        />
                      </a>
                      <i
                        onClick={() => {
                          this.openFN();
                        }}
                        className="fa fa-paperclip attachment-pop"
                        style={{ cursor: "pointer" }}
                      ></i>
                      <a
                        href="javascript:void(0);"
                        class="mr-3"
                        onClick={this.clickPrintPdf}
                      >
                        <i className="fas fa-print fa-2x text-color"></i>
                      </a>
                      <a
                        href="javascript:void(0);"
                        class="mr-2"
                        onClick={this.clickDownloadPdf}
                      >
                        <i className="fas fa-download fa-2x text-color"></i>
                      </a>
                    </div>
                  </div>
                  {/* <div class="row">
                                <div class="row col-md-12">
                                    <h4 class="col-md-10" style={{textAlign:'center'}}>DCG Viewer</h4><h5 class="col-md-2"  style={{textAlign:'right',color:'#2470af',cursor:'pointer'}} onClick={this.onCancelPdfViewerPopup}>Close</h5>
                                </div>
                            </div> */}
                  <div class="row">
                    <div class="col-md-4" style={{ textAlign: "left" }}>
                      <button
                        onClick={this.clickPrevPdf}
                        disabled={this.state.btnPrevPdfDisabled}
                        class="btn btn-primary"
                      >
                        &lt;&lt; Prev
                      </button>
                    </div>

                    <div class="col-md-4" style={{ textAlign: "left" }}>
                      {/* <button onClick={this.clickPrintPdf} class="btn btn-primary">Print</button>
                                    &nbsp;&nbsp;&nbsp;
                                    <button onClick={this.clickDownloadPdf} class="btn btn-primary">Download</button> */}
                    </div>

                    <div class="col-md-4" style={{ textAlign: "right" }}>
                      <button
                        onClick={this.clickNextPdf}
                        disabled={this.state.btnNextPdfDisabled}
                        class="btn btn-primary"
                      >
                        Next &gt;&gt;
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    &nbsp;<br></br>&nbsp;
                  </div>
                  <div class="col-md-12 react-pdf__Document_p">
                    <AllPagesPDFViewer
                      pdf={
                        this.state.samplePdfFilesList[
                          this.state.currentPdfFileIndex
                        ].fileurl
                      }
                    />
                  </div>
                </SweetAlert>
              </div>
            )}
          </div>
        </LoadingOverlay>

        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(DailySummary);
